import { LoadingModal } from '~/modules/@shared/components';

export default function ProcessingModal({ processingOpen }: { processingOpen: boolean }) {
  return <LoadingModal open={processingOpen} title="Processing" description="This may take a few moments." />;
}
